import {
    List,
    Datagrid,
    TextField,
    ListProps,
    FunctionField,
    DateField,
    Pagination
} from 'react-admin'
import { Record, useTranslate } from 'ra-core'
import datagridStyles from '../../layout/styles/datagridStyles'
import PresetListFilters from './PresetListFilters'
import DatagridPublishedColumnContent from '../../components/common/DatagridPublishedColumnContent'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import PresetBulkActionButtons from './PresetBulkActionButtons'
import { DEFAULT_PER_PAGE, ROWS_PER_PAGE } from '../../globals'

const PresetList = (props: ListProps) => {
    const datagridClasses = datagridStyles()
    const translate = useTranslate()

    return (
        <List
            {...props}
            sort={{ field: 'internal_name', order: 'DESC' }}
            perPage={DEFAULT_PER_PAGE}
            filters={PresetListFilters}
            bulkActionButtons={<PresetBulkActionButtons listProps={props} isWithActionsFlush />}
            pagination={<Pagination rowsPerPageOptions={ROWS_PER_PAGE} />}
        >
            <Datagrid body={<CustomDatagridBody />} classes={datagridClasses} rowClick="edit">
                <TextField
                    source="internal_name"
                    label={translate('manager.resources.preset.internal_name')}
                />
                <TextField
                    source="public_name"
                    label={translate('manager.resources.preset.public_name')}
                />
                <FunctionField
                    source="active"
                    label={translate('manager.resources.general.status')}
                    render={(record?: Record | undefined) => (
                        <DatagridPublishedColumnContent record={record} />
                    )}
                />
                <DateField
                    label={translate('manager.resources.general.last_updated')}
                    source="updated_at"
                    showTime
                />
            </Datagrid>
        </List>
    )
}
export default PresetList
